import { render, staticRenderFns } from "./_right.vue?vue&type=template&id=bfdbfbee&scoped=true&"
import script from "./_right.vue?vue&type=script&lang=js&"
export * from "./_right.vue?vue&type=script&lang=js&"
import style0 from "./_right.vue?vue&type=style&index=0&id=bfdbfbee&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bfdbfbee",
  null
  
)

export default component.exports